// extracted by mini-css-extract-plugin
module.exports = {"active":"nav-module--active--1QmHH"};